import { isUndefined } from 'lodash';
import type {
  AddUserPayload,
  LoggedUser,
  LoggedUserResponse,
  UpdateUserPayload,
  User,
  UserList,
  UserListResponse,
  UserResponse,
} from '.';
import type { ApiResponse } from '..';

export const userListResponseMapper = (
  res: ApiResponse<UserListResponse>,
): UserList => {
  const mappedData: User[] = res.data.users.map((item) => ({
    ...item,
    firstName: item.first_name,
    lastName: item.last_name,
    isActive: item.is_active,
    lastLogin: item.last_login ? new Date(item.last_login) : null,
    passwordExpiresAt: item.password_expires_at,
  }));
  return { ...res.data, users: mappedData };
};

export const userResponseMapper = (res: ApiResponse<UserResponse>): User => ({
  ...res.data,
  firstName: res.data.first_name,
  lastName: res.data.last_name,
  lastLogin: res.data.last_login,
  isActive: res.data.is_active,
  is2FAConfigured: res.data.is_2fa_configured,
  passwordExpiresAt: res.data.password_expires_at,
});

export const addUserPayloadMapper = (payload: AddUserPayload) => {
  const { firstName, lastName, password, email, type } = payload;
  return {
    first_name: firstName,
    last_name: lastName,
    email,
    password,
    type,
  };
};

export const updateUserPayloadMapper = (payload: UpdateUserPayload) => {
  const { firstName, lastName, type, isActive } = payload;
  return {
    first_name: firstName,
    last_name: lastName,
    type,
    is_active: isActive,
  };
};

export const loggedUserResponseMapper = (
  res: ApiResponse<LoggedUserResponse>,
): LoggedUser => {
  const mappedData: LoggedUser = {
    ...res.data,
    firstName: res.data.first_name,
    lastName: res.data.last_name,
    lastLogin: res.data.last_login,
    isActive: res.data.is_active,
    isConnectedWithProcessing: res.data.is_connected_with_processing,
    featureFlags: res.data.feature_flags,
    passwordExpiresAt: res.data.password_expires_at,
  };

  if (!isUndefined(res.data.is_2fa_configured)) {
    mappedData.is2FAConfigured = res.data.is_2fa_configured;
  }

  return mappedData;
};
